module.exports = __webpack_public_path__ + "static/img/shoppingCard.f191b46b.svg";